import React from 'react';
import './AnimatedToolTitle.css';

const AnimatedToolTitle = ({ title }) => {
  // Split the title into individual characters
  const letters = title.split('');
  const totalLetters = letters.length;
  
  return (
    <div className="animated-tool-title-container">
      <h1 className="animated-tool-title">
        {letters.map((letter, index) => (
          <span
            key={index}
            className={letter === ' ' ? 'tool-title-letter tool-title-space' : 'tool-title-letter'}
            style={{
              '--delay': `${index * 0.1}s`,
              '--wave-delay': `${index * 0.6}s`
            }}
          >
            {letter === ' ' ? '\u00A0' : letter}
          </span>
        ))}
      </h1>
    </div>
  );
};

export default AnimatedToolTitle;
